import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { filterKey: String }

  connect() {
    this.element.addEventListener("change", this.filterChanged.bind(this))
    this.element.addEventListener("filter:clear", this.clearFilter.bind(this))

    setTimeout(() => {
      this.dispatchInitializedEvent()
    }, 0)
  }

  dispatchInitializedEvent() {
    const value = this.getValue()
    if (!value) return

    const event = new CustomEvent("filter:initialized", {
      detail: { label: this.getLabel(), value, filterKey: this.filterKeyValue, showAppliedFilterLabel: false }
    })

    this.element.dispatchEvent(event)
  }

  filterChanged() {
    const detail = { label: this.getLabel(), value: this.getValue(), filterKey: this.filterKeyValue, showAppliedFilterLabel: false }
    const event = new CustomEvent("filter:change", { detail })

    this.element.dispatchEvent(event)
  }

  clearFilter() {
    this.element.checked = false
    this.element.dispatchEvent(new Event("change"))
  }

  getLabel() {
    return this.element.labels[0].innerText
  }

  getValue() {
    if (this.element.checked) {
      return this.element.value
    }

    return null
  }
}
